// @ts-nocheck

import { reduce as _reduce, uniq as _uniq } from 'lodash';

import { selectBasketItems, selectBasketLoading } from '../selectors/basket/basketPrimary.selector';
import BetBuilder from '../states/betbuilder';

export const buildMessageBasketFromData = (state) => {
  const items = selectBasketItems(state);
  const loading = selectBasketLoading(state);

  let basket = _reduce(
    items,
    (result, item) => {
      if (item.betbuilder && item.selectionItems) {
        item.selectionItems.forEach((bitem) => {
          result.matches.push(bitem.matchId);
          result.bets.push(bitem.betId);
          if (BetBuilder.isMultichoiceItem(bitem)) {
            bitem.outcomeIds.forEach((outcomeId) => result.outcomes.push(outcomeId));
          } else {
            result.outcomes.push(bitem.outcomeId);
          }
        });
        return result;
      } else {
        result.matches.push(item.matchId);
        result.bets.push(item.betId);
        result.outcomes.push(item.oddId);
        return result;
      }
    },
    {
      matches: [],
      bets: [],
      outcomes: [],
    },
  );

  basket = { matches: _uniq(basket.matches), bets: _uniq(basket.bets), outcomes: _uniq(basket.outcomes) };
  return {
    basket,
    loading,
  };
};
